import authApiService from "./userApiService";

const handleError = (error) => {
  console.error("Position Tip API Error:", error);
  return {
    success: false,
    error: error.response?.data?.error || error.message || "An error occurred",
    statusCode: error.response?.status
  };
};

const handleSuccess = (response) => ({
  success: true,
  data: response.data,
  statusCode: response.status
});

const normalizePosition = (pos = "") =>
  String(pos)
    .trim()
    .toLowerCase()
    .replace(/\s*\/\s*/g, "/");

export const positionTipoutService = {
  async getBalances(position, params = {}) {
    try {
      const pos = normalizePosition(position);
      const query = new URLSearchParams();
      if (params.startDate && params.endDate) {
        query.append("startDate", params.startDate);
        query.append("endDate", params.endDate);
      }
      const qs = query.toString() ? `?${query.toString()}` : "";
      const response = await authApiService.get(`/position-tips/${pos}/balances${qs}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getTipHistory(position, params = {}) {
    try {
      const pos = normalizePosition(position);
      const query = new URLSearchParams();
      if (params.startDate && params.endDate) {
        query.append("startDate", params.startDate);
        query.append("endDate", params.endDate);
      }
      const qs = query.toString() ? `?${query.toString()}` : "";
      const response = await authApiService.get(`/position-tips/${pos}/history${qs}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getEmployees(position) {
    try {
      const pos = normalizePosition(position);
      const response = await authApiService.get(`/position-tips/${pos}/employees`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async addRecord(position, data) {
    try {
      const pos = normalizePosition(position);
      const response = await authApiService.post(`/position-tips/${pos}`, data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async updateRecord(position, id, data) {
    try {
      const pos = normalizePosition(position);
      const response = await authApiService.put(`/position-tips/${pos}/${id}`, data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async deleteRecord(position, id) {
    try {
      const pos = normalizePosition(position);
      const response = await authApiService.delete(`/position-tips/${pos}/${id}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getEditLogs(position, params = {}) {
    try {
      const pos = normalizePosition(position);
      const query = new URLSearchParams();
      if (params.startDate && params.endDate) {
        query.append("startDate", params.startDate);
        query.append("endDate", params.endDate);
      }
      if (params.limit) {
        query.append("limit", params.limit);
      }
      const qs = query.toString() ? `?${query.toString()}` : "";
      const response = await authApiService.get(`/position-tips/${pos}/edit-logs${qs}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async clearEditLogs(position) {
    try {
      const pos = normalizePosition(position);
      const response = await authApiService.delete(`/position-tips/${pos}/edit-logs`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  }
};
